import { colors } from '@ardoq/design-tokens';

export enum LoaderSize {
  SMALL = 20,
  MEDIUM = 50,
  LARGE = 100,
}

export enum LoaderColor {
  BRAND = 'brand',
  GRAY = 'gray',
  LIGHT = 'light',
  WHITE = 'white',
}

export const ARDOQ_LOADER_COLORS: Record<LoaderColor, string> = {
  [LoaderColor.BRAND]: colors.iconBrand,
  [LoaderColor.GRAY]: colors.iconStrong,
  [LoaderColor.LIGHT]: colors.icon,
  [LoaderColor.WHITE]: colors.iconOnInvertedStrong,
};

export const LOADER_LABEL_TEXT = 'Loading';
export const LOADER_ARIA_LABEL = 'loader';
